import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileLines = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.05 2.55V5.85H13.35M7.05 9.3H10.95M7.05 11.85H10.95M5.25 2.4H10.2L13.5 5.7V15C13.5 15.1591 13.4368 15.3117 13.3243 15.4243C13.2117 15.5368 13.0591 15.6 12.9 15.6H5.25C5.09087 15.6 4.93826 15.5368 4.82574 15.4243C4.71321 15.3117 4.65 15.1591 4.65 15V3C4.65 2.84087 4.71321 2.68826 4.82574 2.57574C4.93826 2.46321 5.09087 2.4 5.25 2.4Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFileLines;
